<main class="page-main">

  <div class="container-fluid layout layout--modal">

    <div class="layout__main">
      <div class="question question--claims">

        <div class="card card--incident-details">
          <div class="card__content">
            <h5 class="mb-30">Incident Details</h5>

            @for (question of questions; track question) {
              <!--Checkbox Select-->
              @if (question?.cent_aq_question_type_id === QuestionType.multiselect) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-checkbox-multiple
                    [question]="question"
                    [showLabel]="true"
                    [readOnly]="readonly"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-checkbox-multiple>
                </div>
              }
              <!-- Radio button -->
              @if (question?.cent_aq_question_type_id == QuestionType.radio) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-radio
                    [question]="question"
                    [readOnly]="readonly"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-radio>
                </div>
              }
              @if (question?.cent_aq_question_type_id === QuestionType.radio_column_parent) {
                <app-question-radio-column-parent
                  [question]="question"
                  (parentQuestionAnswer)="questionResponse($event)">
                </app-question-radio-column-parent>
              }
              <!-- Slider -->
              @if (question?.cent_aq_question_type_id == QuestionType.slider_si
                || question?.cent_aq_question_type_id == QuestionType.slider_excess) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-slider-parent
                    [question]="question"
                    [readOnly]="readonly"
                    [isExcessSlider]="false"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-slider-parent>
                </div>
              }
              <!--Text Box-->
              @if (question?.cent_aq_question_type_id == QuestionType.textbox) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-textbox
                    [question]="question"
                    [readOnly]="readonly"
                    [showLabel]="true"
                    [editModal]="true"
                    [isIdInput]="question?.cent_aq_question_type_id == QuestionType.id_number"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-textbox>
                </div>
              }
              <!--Question Tel-->
              @if (question?.cent_aq_question_type_id == QuestionType.tel) {
                <div class="form-group"
                  >
                  <app-question-tel
                    [question]="question"
                    [readOnly]="readonly"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-tel>
                </div>
              }
              <!--Text Box Icon-->
              @if (question?.cent_aq_question_type_id == QuestionType.id_number
                || question?.cent_aq_question_type_id == QuestionType.passport) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-textbox-icon
                    [question]="question"
                        [readOnly]="question?.cent_aq_question_type_id == QuestionType.id_number
                        || question?.cent_aq_question_type_id == QuestionType.passport"
                    [showLabel]="true"
                    [isIdInput]="question?.cent_aq_question_type_id == QuestionType.id_number"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-textbox-icon>
                </div>
              }
              <!--Text Box-->
              @if (question?.cent_aq_question_type_id == QuestionType.currency) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-currency
                    [question]="question"
                    [readOnly]="readonly"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-currency>
                </div>
              }
              <!--Text Box-->
              @if (question?.cent_aq_question_type_id == QuestionType.currency_readonly) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-currency-readonly
                    [question]="question"
                    [readOnly]="true"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-currency-readonly>
                </div>
              }
              @if (question?.cent_aq_question_type_id == QuestionType.location) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-location
                    [question]="question"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-location>
                </div>
              }
              <!--Company Registration Input-->
              @if (question?.cent_aq_question_type_id == QuestionType.registration_number) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-company-registration
                    [question]="question"
                    [readOnly]="readonly"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-company-registration>
                </div>
              }
              <!--Location-->
              @if (question?.cent_aq_question_type_id == QuestionType.address) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-address
                    [question]="question"
                    [readOnly]="readonly"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-address>
                </div>
              }
              <!--Dropdown-->
              @if (question?.cent_aq_question_type_id == QuestionType.dropdown) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-dropdown
                    [readOnly]="readonly"
                    [question]="question"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-dropdown>
                </div>
              }
              <!--Select Button-->
              @if (question?.cent_aq_question_type_id == QuestionType.select_button) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-select-button
                    [readonly]="readonly"
                    [question]="question"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-select-button>
                </div>
              }
              <!--Checkbox Image-->
              @if (question?.cent_aq_question_type_id === QuestionType.checkbox_image) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-checkbox-image
                    [readOnly]="readonly"
                    [question]="question"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-checkbox-image>
                </div>
              }
              <!--Textbox Autocomplete-->
              @if (question?.cent_aq_question_type_id == QuestionType.vehicle_make
                || question?.cent_aq_question_type_id == QuestionType.vehicle_model
                || question?.cent_aq_question_type_id == QuestionType.vehicle_year
                || question?.cent_aq_question_type_id == QuestionType.industry
                || question?.cent_aq_question_type_id == QuestionType.profession) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-autocomplete
                    [question]="question"
                    [readOnly]="readonly"
                    [showLabel]="true"
                    [inputType]="question?.cent_aq_question_type_id == QuestionType.vehicle_year ? 'number' : 'text'"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-autocomplete>
                </div>
              }
              <!-- Plus Minus -->
              @if (question?.cent_aq_question_type_id === QuestionType.plus_minus) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-plus-minus
                    [question]="question"
                    [readOnly]="readonly"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-plus-minus>
                </div>
              }
              @if (question?.cent_aq_question_type_id == QuestionType.rebuild_cost) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-rebuild-cost
                    [question]="question"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-rebuild-cost>
                </div>
              }
              @if (question?.cent_aq_question_type_id === QuestionType.textarea) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-textarea
                    [question]="question"
                    [readonly]="readonly"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-textarea>
                </div>
              }
              @if (question?.cent_aq_question_type_id === QuestionType.radio_image) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-radio-image-details
                    [question]="question"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-radio-image-details>
                </div>
              }
              @if (question?.cent_aq_question_type_id == QuestionType.label_amount_parent
                || question?.cent_aq_question_type_id == QuestionType.label_perc_parent
                || question?.cent_aq_question_type_id == QuestionType.textbox_perc_parent
                || question?.cent_aq_question_type_id == QuestionType.textbox_amount_parent) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-label-textbox-parent
                    [question]="question"
                    [itemQuestions]="getItemChildrenQuestions(question)"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-label-textbox-parent>
                </div>
              }
              @if (question?.cent_aq_question_type_id == QuestionType.parent_question_variation_one) {
                <div class="form-group form-group--lg">
                  <app-question-parent-variation-one
                    [question]="question"
                    [childrenQuestions]="getQuestionChildren(question)"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-parent-variation-one>
                </div>
              }
              @if (question?.cent_aq_question_type_id == QuestionType.parent_question_variation_two) {
                <div class="form-group form-group--lg">
                  <app-question-parent-variation-two
                    [question]="question"
                    [childrenQuestions]="getQuestionChildren(question)"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-parent-variation-two>
                </div>
              }
              @if (question?.cent_aq_question_type_id == QuestionType.toggle_parent) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-toggle-parent
                    [question]="question"
                    [itemQuestions]="getItemChildrenQuestions(question)"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-toggle-parent>
                </div>
              }
              @if (question?.cent_aq_question_type_id == QuestionType.year) {
                <div class="form-group"
                  >
                  <app-question-year
                    [question]="question"
                    [readOnly]="readonly"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-year>
                </div>
              }
              @if (question?.cent_aq_question_type_id === QuestionType.pills) {
                <app-question-pill-buttons
                  [question]="question"
                  [isRadio]="false"
                  [showLabel]="false"
                  [isUploadPills]="true"
                  (questionAnswer)="questionResponse($event)">
                </app-question-pill-buttons>
              }
              <!--Question Toggle Button-->
              <div class="form-group form-group--lg">
                @if (question?.cent_aq_question_type_id === QuestionType.toggle) {
                  <app-question-toggle-button
                    [question]="question"
                    [readonly]="readonly"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-toggle-button>
                }
              </div>
              <!--Question Time Picker-->
              <div class="form-group form-group--lg">
                @if (question?.cent_aq_question_type_id === QuestionType.time) {
                  <app-question-timepicker
                    [question]="question"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-timepicker>
                }
              </div>
              <!--Question Time Picker-->
              <div class="form-group form-group--lg">
                @if (question?.cent_aq_question_type_id === QuestionType.radio_icon) {
                  <app-question-dropdown
                    [question]="question"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-dropdown>
                }
              </div>
              <div class="form-group form-group--lg">
                @if (question?.cent_aq_question_type_id == QuestionType.date) {
                  <app-question-date-picker
                    [question]="question"
                    [numberMonths]="1"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-date-picker>
                }
              </div>
              <!--Question Number Textbox-->
              @if (question?.cent_aq_question_type_id == QuestionType.number) {
                <div class="form-group"
                  >
                  <app-question-number-textbox
                    [question]="question"
                    [readOnly]="readonly"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-number-textbox>
                </div>
              }
              <!--Question Number Textbox-->
              @if (question?.cent_aq_question_type_id === QuestionType.odometer_reading) {
                <div class="form-group"
                  >
                  <app-question-odometer-reading
                    [question]="question"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-odometer-reading>
                </div>
              }
              <!--Question Item List-->
              @if (question?.cent_aq_question_type_id == QuestionType.family_list
                || question?.cent_aq_question_type_id === QuestionType.allrisk_list
                || question?.cent_aq_question_type_id == QuestionType.vehicle_list) {
                <app-question-items-list
                  [question]="question"
                  [selectedItemId]="collation?.session_item_id"
                  [editCardMarginBottom]="true"
                  [itemQuestions]="getItemChildrenQuestions(question)"
                  (questionAnswer)="questionResponse($event)">
                </app-question-items-list>
              }
              @if (question.cent_aq_question_type_id == QuestionType.dob) {
                <div class="form-group form-group--lg"
                  >
                  <app-question-date-of-birth
                    [question]="question"
                    [showLabel]="true"
                    (questionAnswer)="questionResponse($event)">
                  </app-question-date-of-birth>
                </div>
              }
            }



          </div>


        </div>

      </div>
    </div>
  </div>


</main>

<app-disclaimer></app-disclaimer>

<footer class="question-tray">
  <div class="container">
    <div class="question-tray__controls">
      <div class="question-tray__btns">
        <a href="javascript:;" (click)="cancel()" class="button button--lg button--secondary">Cancel</a>
        <a href="" class="button button--lg button--primary" disabled="true">Save</a>
      </div>
    </div>
  </div>
</footer>